<template>
	<div class="cargolist">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
			<el-tab-pane :label="tab.name" :name="tab.name" v-for="(tab,index) in tabs" :key="index" :disabled="!tabenabled">
				<span slot="label" v-if="">{{ tab.name }}</span>
				<el-row>
					<el-col :span="17">
						<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
						<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
					</el-col>
					<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
					<el-col :span="4"><el-input placeholder="搜索" ref="searchbox" v-model="searchbox" size="small" @keyup.enter.native="getgriddata()"></el-input></el-col>
					<el-col :span="2" class="rightcol">
						<el-popover placement="bottom-end" :width="filterlist.length > 0 ? 500 : 350" trigger="click">
							<table class="htmltable">
								<tr>
									<td>产品ID</td>
									<td><el-input type="textarea" rows="3" v-model="searchlist.pkcno" size="mini"></el-input>
									</td>
									<td rowspan="9" valign="top" class="filter" v-if="filterlist.length > 0">
										<div>常用筛选</div>
										<ul>
											<li v-for="(item, index) in filterlist">
												<el-radio v-model="searchlist.fname" :label="item.fname" @change="Setfilterchecked">{{ item.fname }}</el-radio>
											</li>
										</ul>
									</td>
								</tr>
								<tr>
									<td>商品编号</td>
									<td><el-input type="textarea" rows="3" v-model="searchlist.cno" size="mini"></el-input>
									</td>
								</tr>
								<tr>
									<td>商品名称</td>
									<td><el-input type="textarea" rows="3" v-model="searchlist.cname" size="mini"></el-input>
									</td>
								</tr>
								<tr>
									<td>商品品牌</td>
									<td><el-input type="text" v-model="searchlist.brand" size="mini"></el-input>
									</td>
								</tr>
								<tr>
									<td>商品分类</td>
									<td><el-select v-model="searchlist.p_sort" filterable clearable size="mini" remote :remote-method="getsort" style="width:100%" placeholder="可输入分类名称搜索">
						    <el-option
						      v-for="item in sortlist"
						      :key="item.p_sort"
						      :label="item.p_sort"
						      :value="item.p_sort">
						    </el-option>
						  </el-select></el-input>
									</td>
								</tr>
								<tr>
									<td>语言类型</td>
									<td>
										<el-select size="mini" v-model="searchlist.lang" placeholder="" style="width:100%">
											<el-option :label="item.label" :value="item.value" v-for="(item, index) in langlist" :key="index"></el-option>
										</el-select>
									</td>
								</tr>
								<tr>
									<td>新增账号</td>
									<td>
										<el-autocomplete
											ref="u_account"
											:trigger-on-focus="false"
											v-model="searchlist.u_account"
											:fetch-suggestions="searchuser"
											placeholder="请输入会员卡\账号\姓名"
											value-key="u_account"
											size="mini"
											style="width:100%"
										>
											<template slot-scope="{ item }">
												<div>{{ item.u_account }} ( {{ item.u_name }} {{ item.vipaccount }} )</div>
											</template>
										</el-autocomplete>
									</td>
								</tr>
								<tr>
									<td><label>新增时间</label></td>
									<td style="text-align:left;">
										<el-date-picker
											v-model="searchlist.starttime"
											type="date"
											placeholder="选择开始日期"
											size="mini"
											value-format="yyyy-MM-dd"
										></el-date-picker>
									</td>
								</tr>
								<tr>
									<td><label>至</label></td>
									<td>
										<el-date-picker v-model="searchlist.endtime" type="date" placeholder="选择结束日期" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
									</td>
								</tr>
								<tr>
									<td colspan="4" class="bottombtn">
										<el-button @click="GetTabData()" type="warning" size="mini">查询</el-button>
										<el-button @click="ClearSearch(0)" size="mini">清空</el-button>
									</td>
								</tr>
							</table>

							<el-link slot="reference" type="primary">更多筛选</el-link>
						</el-popover>
					</el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
					<el-col :span="24" v-if="activeName!=''">
						<tableuiexpand v-if="activeName.indexOf('expand')>-1"
							style="width:100%;"
							v-loading="loading"
							:ref="'cargolistable_'+index"
							:tableData="cargolist"
							:columns="tab.columns"
							@gridhandle="gridhandle"
							:gridheight="gridheight"
							@gridsort="gridsort"
							@checkboxchange="checkboxchange"
							@gridscroll="gridscroll"
							:istop="istop"
							@rowdblclick="rowdblclick"
							:soncolumns="tab.soncolumns"
							:isexpand="isexpand"
							@getExpandsRow="getExpandsRow"
							:rowkey="rowkey"
						></tableuiexpand>
						
						<tableui
						    v-if="activeName.indexOf('expand')<0" 
							style="width:100%;"
							v-loading="loading"
							ref="cargolistable"
							:tableData="cargolist"
							:columns="tab.columns"
							@gridhandle="gridhandle"
							:gridheight="gridheight"
							@gridsort="gridsort"
							@checkboxchange="checkboxchange"
							@gridscroll="gridscroll"
							:istop="istop"
						></tableui>
					</el-col>
				</el-row>
				<div>
					<el-row>
						<el-col :span="12">
							<span>共 {{ count }} 条数据</span>
						</el-col>
					</el-row>
				</div>
			</el-tab-pane>
			</el-tabs>
		</el-card>
		<importwin ref="importwin"></importwin>
		<importFile ref="importFile"></importFile>
		<exportwin ref="exportwin"></exportwin>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableuiexpand from '@/components/table/tablegrid_expand.vue';//可展开的
import tableui from '@/components/table/tablegrid.vue';//列表
import Utils from '../../lib/util.js';
import importwin from '@/components/order/importwin.vue'; //万能导入
import importFile from '@/components/order/importFile.vue'; //文件上传
import exportwin from '@/components/order/exportwin.vue';
export default {
	components: {
		tableuiexpand,
		tableui,
		handlerbutton,
		importwin,
		importFile,
		exportwin
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			searchlist: {
				pkcno:'',
				cno:'',
				cname:'',
				u_account: '' ,
				starttime:'',
				endtime:'',
				lang:'',
				fixfilter: '',
				fixsort: '',
				fname:''
			},
			langlist:[],
			activeName:'',
			istop: false,
			searchbox: '',
			activeTabIndex: 0, //激活的选项卡index
			pickerOptions: '',
			cargolist: [],
			gridheight:'0px',
			loading: false,
			selloading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '商品库管理', //当前操作的功能模块名称
			selectedall: false,
			checkedrow: [],
			count: 0,
			divclass: 'cargolist',
			type:'',
			storehouse:'',
			searchparam:'0',//获取列表数据的条件,0-商品库列表中的查询方式，上级看下级  1--用于列表作为下单选择商品库时的筛选 2-用于查找公海商品资料添加到自己的库中
			sortlist:[],
			activetab:'',
			cargotype:'',
			tabenabled:true,
			filterlist:[],
			isexpand:false,
			rowkey:'pkcno'
		};
	},
	mounted() {
		var that = this;
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/baseinfo/cargolist.scss');
			that.init(that.urlparam);
		});

		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
	//	console.log('加载');
	},
	methods: {
		init(param){
			var that=this;
			if(param.type!=undefined){
				this.type=param.type;
				 if(param.storehouse!=undefined)
					this.storehouse=param.storehouse;
				 if(param.searchparam!=undefined)
					this.searchparam=param.searchparam;
				if(param.searchlist!=undefined)
					this.searchlist=param.searchlist;
				if(param.cargotype!=undefined)
				{
					if(param.cargotype!=''){
						this.cargotype=param.cargotype;
					}
					this.tabenabled=false;
				}
				this.gridheight='330px';
				this.$nextTick(function(){
					that.$refs.searchbox[0].focus();
				}); 
			}
			else
				this.gridheight= (window.innerHeight * 63) / 100 + 'px';
			that.getTabs();
			this.getsort('');
			that.GetLanglist();
		},
		//获取常用筛选条件
		GetFilter() {
			var that = this;
			//debugger
			this.$apipost.get.GetFilter({ l_mode: this.mode, type: this.tabs[this.activeTabIndex].type }).then(res => {
				if (res != '') {
					that.filterlist = res.data;
				}
			});
		},
		//设置常用筛选
		Setfilterchecked(value) {
			this.searchlist.fname = value;
		},
		getsort(val){
			var that = this;
			this.$apipost.get.GetCargoSort_Last({searchkey:val,cargotype:this.cargotype}).then(res => {
				that.sortlist = res.list;
			});
		},
		//获取选项卡
		getTabs() {
			var that=this;
			this.$apipost.get.GetTabs({ parentid: 213 }).then(res => {
				//console.log('tabs',res.tabs);
				that.tabs = res.tabs;
				if(that.cargotype!='')
					that.activeTabIndex = 1;
				else
					that.activeTabIndex = 0;
				
				that.activeName = that.tabs[that.activeTabIndex].type;
				that.activetab = that.tabs[that.activeTabIndex].name;
				
				that.GetTabData();
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				pkcno:'',
				cno:'',
				cname:'',
				u_account: '' ,
				starttime:'',
				endtime:'',
				lang:'',
				fixfilter: '',
				fixsort: '',
				fname:''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 94) {
					that.refreshgrid(false);
				}
			}
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
				if(this.activeTabIndex==1)
					this.cargotype='mobile';
				else
					this.cargotype='';
				this.getsort('');
				this.searchlist.fname='';
				this.searchlist.fixfilter='';
				this.searchlist.fixsort='';
			}
			this.GetFilter(); //加载选项卡对应的筛选条件
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		getgriddata(){
			if(this.searchbox=='')
				this.ClearSearch();
			this.refreshgrid(true);
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.cargolist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				var paraminfo = {
					search: this.GetSearchObj(),
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					tab: this.activeName,
					l_mode: this.mode,
					//storehouse:this.storehouse,//所属仓库
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					userid: localStorage.getItem('userid')
				};
				//console.log('GetBaseCargoList',JSON.stringify(paraminfo));
				this.$apipost.get.GetBaseCargoList({ paraminfo: paraminfo }).then(res => {
					that.loading = false;
					//console.log('商品列表',res);
					res.data=that.SetGridChild(res.data);
					
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.cargolist=that.cargolist.concat(res.data);
						} else {
							that.cargolist = res.data;
						}
					}else{
						that.cargolist=[];
					}
					this.count = res.count;
					if(that.activeName.indexOf('expand')>-1){
						that.$nextTick(function(){
							that.$refs['cargolistable_'+that.activeTabIndex][0].SetTableList(that.cargolist);
						});
					}
				});
			}
		},
		//组合筛选条件
		GetSearchObj() {
			var search = new Object();
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}else{
				search=JSON.parse(JSON.stringify(this.searchlist));
			}
			if (search.fname != '') {
				var that = this;
				var searchtype = '';
				this.filterlist.forEach(e => {
					if (e.fname == search.fname) {
						if (e.handlertype == 'filter') {
							searchtype = e.searchtype;
							search.fixfilter=e.filter;
							return false;
						} else if (e.handlertype == 'sort') {
							searchtype = '';
							search.fixfilter = '';
							search.fixsort = e.filter;
							return false;
						}
					}
				});
				search.searchtype = searchtype;
			}
			
			if(this.storehouse!='')
				search.storehouse=this.storehouse;
			if(search.cno!=undefined)
				search.cno=search.cno.replace(/\n/g, ',');
			search.ispublic=this.searchparam;
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				//console.log('列配置',res);
				var resobj=JSON.parse(JSON.stringify(res));
				that.tabs[that.activeTabIndex].columns = resobj;
				//debugger
				if (that.tabs[that.activeTabIndex].type.indexOf('_expand') > -1) {
					//设置子表的列配置，去掉勾选、去掉模板列
					//debugger e.field=='checkbox'||
					var colums = resobj.filter(function(e) {
						return  e.field=='price'||e.field=='outprice'||e.field=='spec'||e.field=='num'||e.field=='pkcno'||e.field=='cno';
					});
					that.tabs[that.activeTabIndex].soncolumns = colums;
				}
				that.refreshgrid(true);
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'del') {
				this.DelBaseCargo();
			}
			if (e.event == 'add') {
				Utils.$emit('go', {
					l_url: '/baseinfo/addcargo',
					l_name: '新增商品',
					l_id: e.l_id,
					urlparam: {id:''}
				});
			}
			if(e.event=='import'){
				if (this.$refs.importwin != undefined) {
					this.$refs.importwin.init({
						mode:'商品库导入',
						dialogtitle:e.l_name,
						isreload:true
					  }
					);
				}
			}
			if(e.event=='uploadcargopic')//上传图片
			{
				if (this.$refs.importFile != undefined) {
					this.$refs.importFile.init({
						mode:'上传图片',
						dialogtitle:e.l_name,
						cargotype:this.cargotype
					  }
					);
				}
			}
			if(e.event=='private'){
				this.SetPublic(0);
			}
			if(e.event=='public'){
				this.SetPublic(1);
			}
			if(e.event=='allpublic'){
				this.SetPublic(2);
			}
			if(e.event=='enabled'){
				this.SetEnabled(true);
			}
			if(e.event=='disenabled'){
				this.SetEnabled(false);
			}
			if(e.event=='cargoissue'){
				//console.log('tablename',e);
				Utils.$emit('go', {
					l_url: '/baseinfo/addcargo',
					l_name: '商品发布',
					l_id: e.l_id,
					urlparam: {id:'',l_tablename:e.l_tablename}
				});
			}
			if(e.event=='cargoissue_update')
			{
				var rows=this.checkedrow;
				if(this.selectedall)
				{
					if(this.cargolist.length==1)
						rows=this.cargolist;
				}
				if(rows.length==1){
					Utils.$emit('go', {
						l_url: '/baseinfo/addcargo',
						l_name: '编辑商品',
						l_id: e.l_id,
						urlparam: {id:rows[0].id,l_tablename:e.l_tablename}
					});
				}
				else
					this.$tool.message('请勾选一条数据操作',2);
			}
			if(e.event=='export'){
				var that=this;
				var searchinfo = this.GetCheckedOrder(false);
				if (searchinfo != '') {
					if (that.$refs.exportwin != undefined) {
						var handtype=9;
						if(this.cargotype=='mobile')
							handtype=10;
						var data=JSON.parse(JSON.stringify(that._data));
						delete data.cargolist;
						delete data.checkedrow;
						that.$refs.exportwin.init({
							searchinfo: searchinfo,
							pageparam: data,
							handtype: handtype
						});
					}
				}
			}
			if(e.event=='synccargoimg'){
				var that = this;
				this.$apipost.post.SyncCargoimg({cargotype:this.cargotype}).then(res => {
					if(res.state=='1')
					{
						this.$tool.message('同步成功',1);
					}else{
						this.$tool.message('同步失败',0);
					}
				});
			}
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//debugger
				if (res.list != undefined) {
					that.langlist=res.list;
				}
			});
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			this.checkedrow = [];
			if (e.event == 'del') {
				//彻底删除
				this.checkedrow.push(this.cargolist[e.index]);
				this.DelBaseCargo();
			}
			if (e.event == 'edit') {
				Utils.$emit('go', {
					l_url: '/baseinfo/addcargo',
					l_name: '修改商品',
					l_id: e.l_id,
					urlparam: {id:this.cargolist[e.index].id}
				});
			}
			if (e.event == 'detail') {
				if(e.colattr!=undefined){
					if(e.colattr.openurl!=undefined){
						let link = document.createElement('a');
						link.style.display = 'none';
						 var param=encodeURIComponent(JSON.stringify({id:this.cargolist[e.index].id.toLowerCase(),p_sort:this.cargolist[e.index].p_sort}));
						link.href = e.colattr.openurl+"?param="+param;
						link.target='_blank';
						document.body.appendChild(link);
						link.click();
					}
				}
			}
		},
		//复选框勾选触发
		checkboxchange(e) {
			//debugger
			if (!e.selectedall) {
				var index=-1;
				var checkedrows=JSON.parse(JSON.stringify(this.checkedrow));
				for(var i=0;i<checkedrows.length;i++){
					if(checkedrows[i].id==e.row.id)
					{
						index=i;
						break;
					}
				}
				if(index>-1)
				{
					this.checkedrow.splice(index,1);
					if(e.selected)
						this.checkedrow.push(e.row);
				}
				else{
					if(e.selected)
						this.checkedrow.push(e.row);
					else
					{
						if(this.checkedrow.length==0)
							this.checkedrow=e.rows;
					}
				}
			}
			else
				this.checkedrow=[];
				
			this.selectedall = e.selectedall;
		},
		//删除订单方法1/2
		DelBaseCargo() {
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				var that = this;
				this.$confirm('确定删除所选数据吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						that.DelBaseCargo2(searchinfo);
					})
					.catch(() => {});
			}
		},
		//删除订单方法2/2
		DelBaseCargo2(searchinfo) {
			var that = this;
			var paraminfo = {
				mode: this.mode,
				tab: this.tabs[this.activeTabIndex].type,
				search: searchinfo,
				sort: this.sort,
				userid:localStorage.getItem('userid'),
				cargotype:this.cargotype
			};
			 // console.log('删除', escape(JSON.stringify(paraminfo)));
			 // return false;
			this.$tool.loading('正在删除',this.divclass);
			this.$apipost.post.DelBaseCargo({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('删除成功', 1);
					that.refreshgrid(true);
				} else {
					if (res.message != '') this.$tool.message(res.message, 0);
					else this.$tool.message('删除失败', 0);
				}
			});
		},
		//重置筛选
		ResetFilterInfo() {
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		searchuser(val, cb) {
			var that = this;
			var search = new Object();
			if (this.u_account != '') {
				search.searchbox = this.searchlist.u_account;
			}
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: '会员列表',
						tab: '',
						search: JSON.stringify(search),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						cb(res.data);
					});
				}
			}, 300);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var id = '';
			var isgo = true;
			var search = {
				id: ''
			};
			debugger
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					id += e.id + ',';
				});
				if (id != '') {
					id = id.substring(0, id.length - 1);
					search.id = id; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选数据', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//列表双击
		rowdblclick(e){
			if(this.type=='select'){
				//回填到上级页面
				var row=e.row;
				var rows=new Array();
				rows.push(row);
				this.$parent.$parent.addcargorow(rows);
			}
		},
		SetPublic(ispublic,e){
			var that=this;
			var fun='私有';
			if(ispublic==1)
				fun='公开';
			if(ispublic==2)
				fun='公海';	
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				this.$confirm('确定设置所选数据为【'+fun+'】商品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						that.SetPublic2(searchinfo,ispublic);
					})
					.catch(() => {});
			}
		},
		SetGridChild(list){
			list.forEach(e=>{
				if(e.haschild=='1')
					e.sonDataList=[];
			});
			return list;
		},
		SetPublic2(searchinfo,ispublic){
			var that = this;
			var paraminfo = {
				mode: this.mode,
				tab: this.tabs[this.activeTabIndex].type,
				search: searchinfo,
				sort: this.sort,
				userid:localStorage.getItem('userid'),
				ispublic:ispublic,
				cargotype:this.cargotype
			};
			 // console.log('删除', escape(JSON.stringify(paraminfo)));
			 // return false;
			this.$tool.loading('正在设置',this.divclass);
			this.$apipost.post.SetCargoPublic({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('设置成功', 1);
					that.refreshgrid(true);
				} else {
					this.$tool.message(res.message, 0);
					if(res.localfilename!=undefined)
						this.$tool.downfile(that,res.localfilename);
				}
			});
		},
		SetEnabled(state,e){
			var that=this;
			var fun='禁用';
			if(state==true)
				fun='启用';
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				this.$confirm('确定设置所选商品为【'+fun+'】状态?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						that.SetEnabled2(searchinfo,state);
					})
					.catch(() => {});
			}
		},
		SetEnabled2(searchinfo,state){
			var that = this;
			var paraminfo = {
				mode: this.mode,
				tab: this.tabs[this.activeTabIndex].type,
				search: searchinfo,
				sort: this.sort,
				userid:localStorage.getItem('userid'),
				isenabled:state,
				cargotype:this.cargotype
			};
			 // console.log('删除', escape(JSON.stringify(paraminfo)));
			 // return false;
			this.$tool.loading('正在设置',this.divclass);
			this.$apipost.post.SetCargoenabled({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('设置成功', 1);
					that.refreshgrid(true);
				} else {
					this.$tool.message(res.message, 0);
					if(res.localfilename!=undefined)
						this.$tool.downfile(that,res.localfilename);
				}
			});
		},
		//列表展开时加载子表信息
		getExpandsRow(e) {
			debugger
			e.row.expand = e.expand;
			if (e.expand) {
				//加载子表信息
				this.loadsongrid(e.row, e.index);
			}
		},
		loadsongrid(row, index) {
			var that = this;
			var search =" and pkcno='"+row.pkcno+"' and lang='"+row.lang+"' and spec!='"+row.spec+"'";
			this.loading = true;
			this.$apipost.get.CreateGrid({
			l_mode:this.mode+this.tabs[this.activeTabIndex].type,
			tab:this.tabs[this.activeTabIndex].type,
			pageindex:0,
			showcol:JSON.stringify(that.tabs[that.activeTabIndex].soncolumns),
			pagesize:200,
			sort:' u_createtime ',
			search:search,
			listparam:'',
			iscount:false,
			userid:localStorage.getItem('userid')}).then(reslist => {
				//debugger
				that.cargolist[index].sonDataList=reslist.data;
				that.loading = false;
				that.$refs['cargolistable_'+that.activeTabIndex][0].SetExpandSonList(index, reslist.data);
			});
		}
	}
};
</script>
